/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TerminalPageTabContainer_station$ref = any;
export type stopRoutes_TerminalPageTabContainer_QueryVariables = {|
  terminalId: string
|};
export type stopRoutes_TerminalPageTabContainer_QueryResponse = {|
  +station: ?{|
    +$fragmentRefs: TerminalPageTabContainer_station$ref
  |}
|};
export type stopRoutes_TerminalPageTabContainer_Query = {|
  variables: stopRoutes_TerminalPageTabContainer_QueryVariables,
  response: stopRoutes_TerminalPageTabContainer_QueryResponse,
|};
*/


/*
query stopRoutes_TerminalPageTabContainer_Query(
  $terminalId: String!
) {
  station(id: $terminalId) {
    ...TerminalPageTabContainer_station
    id
  }
}

fragment TerminalPageTabContainer_station on Stop {
  id
  gtfsId
  code
  stops {
    id
    gtfsId
    alerts {
      id
      alertDescriptionText
      alertHash
      alertHeaderText
      alertSeverityLevel
      alertUrl
      effectiveEndDate
      effectiveStartDate
      alertDescriptionTextTranslations {
        language
        text
      }
      alertHeaderTextTranslations {
        language
        text
      }
      alertUrlTranslations {
        language
        text
      }
    }
  }
  alerts {
    id
    alertDescriptionText
    alertHash
    alertHeaderText
    alertSeverityLevel
    alertUrl
    effectiveEndDate
    effectiveStartDate
    alertDescriptionTextTranslations {
      language
      text
    }
    alertHeaderTextTranslations {
      language
      text
    }
    alertUrlTranslations {
      language
      text
    }
  }
  vehicleMode
  stoptimes: stoptimesWithoutPatterns(timeRange: 900, numberOfDepartures: 100, omitCanceled: false) {
    realtimeState
    trip {
      pattern {
        code
        id
      }
      route {
        gtfsId
        shortName
        longName
        mode
        color
        alerts {
          id
          alertDescriptionText
          alertHash
          alertHeaderText
          alertSeverityLevel
          alertUrl
          effectiveEndDate
          effectiveStartDate
          alertDescriptionTextTranslations {
            language
            text
          }
          alertHeaderTextTranslations {
            language
            text
          }
          alertUrlTranslations {
            language
            text
          }
        }
        id
      }
      id
    }
  }
  routes {
    gtfsId
    shortName
    longName
    mode
    color
    alerts {
      id
      alertDescriptionText
      alertHash
      alertHeaderText
      alertSeverityLevel
      alertUrl
      effectiveEndDate
      effectiveStartDate
      alertDescriptionTextTranslations {
        language
        text
      }
      alertHeaderTextTranslations {
        language
        text
      }
      alertUrlTranslations {
        language
        text
      }
      trip {
        pattern {
          code
          id
        }
        id
      }
    }
    patterns {
      code
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "terminalId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "terminalId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gtfsId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alertDescriptionText",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alertHash",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alertHeaderText",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alertSeverityLevel",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alertUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveEndDate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveStartDate",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "language",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "TranslatedString",
  "kind": "LinkedField",
  "name": "alertDescriptionTextTranslations",
  "plural": true,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "TranslatedString",
  "kind": "LinkedField",
  "name": "alertHeaderTextTranslations",
  "plural": true,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "TranslatedString",
  "kind": "LinkedField",
  "name": "alertUrlTranslations",
  "plural": true,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Alert",
  "kind": "LinkedField",
  "name": "alerts",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v17 = [
  (v4/*: any*/),
  (v2/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Pattern",
  "kind": "LinkedField",
  "name": "pattern",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stopRoutes_TerminalPageTabContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Stop",
        "kind": "LinkedField",
        "name": "station",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TerminalPageTabContainer_station"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stopRoutes_TerminalPageTabContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Stop",
        "kind": "LinkedField",
        "name": "station",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Stop",
            "kind": "LinkedField",
            "name": "stops",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleMode",
            "storageKey": null
          },
          {
            "alias": "stoptimes",
            "args": [
              {
                "kind": "Literal",
                "name": "numberOfDepartures",
                "value": 100
              },
              {
                "kind": "Literal",
                "name": "omitCanceled",
                "value": false
              },
              {
                "kind": "Literal",
                "name": "timeRange",
                "value": 900
              }
            ],
            "concreteType": "Stoptime",
            "kind": "LinkedField",
            "name": "stoptimesWithoutPatterns",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "realtimeState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "trip",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Route",
                    "kind": "LinkedField",
                    "name": "route",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v16/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "stoptimesWithoutPatterns(numberOfDepartures:100,omitCanceled:false,timeRange:900)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Route",
            "kind": "LinkedField",
            "name": "routes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Alert",
                "kind": "LinkedField",
                "name": "alerts",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Trip",
                    "kind": "LinkedField",
                    "name": "trip",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Pattern",
                "kind": "LinkedField",
                "name": "patterns",
                "plural": true,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6bdf7b82fdeac6a082ee111ed78e4e5f",
    "id": null,
    "metadata": {},
    "name": "stopRoutes_TerminalPageTabContainer_Query",
    "operationKind": "query",
    "text": "query stopRoutes_TerminalPageTabContainer_Query(\n  $terminalId: String!\n) {\n  station(id: $terminalId) {\n    ...TerminalPageTabContainer_station\n    id\n  }\n}\n\nfragment TerminalPageTabContainer_station on Stop {\n  id\n  gtfsId\n  code\n  stops {\n    id\n    gtfsId\n    alerts {\n      id\n      alertDescriptionText\n      alertHash\n      alertHeaderText\n      alertSeverityLevel\n      alertUrl\n      effectiveEndDate\n      effectiveStartDate\n      alertDescriptionTextTranslations {\n        language\n        text\n      }\n      alertHeaderTextTranslations {\n        language\n        text\n      }\n      alertUrlTranslations {\n        language\n        text\n      }\n    }\n  }\n  alerts {\n    id\n    alertDescriptionText\n    alertHash\n    alertHeaderText\n    alertSeverityLevel\n    alertUrl\n    effectiveEndDate\n    effectiveStartDate\n    alertDescriptionTextTranslations {\n      language\n      text\n    }\n    alertHeaderTextTranslations {\n      language\n      text\n    }\n    alertUrlTranslations {\n      language\n      text\n    }\n  }\n  vehicleMode\n  stoptimes: stoptimesWithoutPatterns(timeRange: 900, numberOfDepartures: 100, omitCanceled: false) {\n    realtimeState\n    trip {\n      pattern {\n        code\n        id\n      }\n      route {\n        gtfsId\n        shortName\n        longName\n        mode\n        color\n        alerts {\n          id\n          alertDescriptionText\n          alertHash\n          alertHeaderText\n          alertSeverityLevel\n          alertUrl\n          effectiveEndDate\n          effectiveStartDate\n          alertDescriptionTextTranslations {\n            language\n            text\n          }\n          alertHeaderTextTranslations {\n            language\n            text\n          }\n          alertUrlTranslations {\n            language\n            text\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n  routes {\n    gtfsId\n    shortName\n    longName\n    mode\n    color\n    alerts {\n      id\n      alertDescriptionText\n      alertHash\n      alertHeaderText\n      alertSeverityLevel\n      alertUrl\n      effectiveEndDate\n      effectiveStartDate\n      alertDescriptionTextTranslations {\n        language\n        text\n      }\n      alertHeaderTextTranslations {\n        language\n        text\n      }\n      alertUrlTranslations {\n        language\n        text\n      }\n      trip {\n        pattern {\n          code\n          id\n        }\n        id\n      }\n    }\n    patterns {\n      code\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0b22a10b3d371672275bcdd043687482';

module.exports = node;
